<mat-toolbar>
  <h4>{{'help.title' | translate}}</h4>
  <button (click)="goBack()" *ngIf="isMarkdown" mat-icon-button>
    <mat-icon>subdirectory_arrow_left</mat-icon>
  </button>
</mat-toolbar>

<div class="content">

  <ng-container *ngIf="!isMarkdown">

    <ng-container *ngFor="let item of filteredIndex">

      <mat-expansion-panel *ngIf="item.entries.length">
        <mat-expansion-panel-header>
          <mat-panel-title>{{item.tagTitle}}</mat-panel-title>
          <mat-panel-description></mat-panel-description>
        </mat-expansion-panel-header>
        <mat-list *ngIf="item.entries.length">
          <mat-list-item (click)="loadReadme(entry.readme)" *ngFor="let entry of item.entries">{{entry.title}}</mat-list-item>
        </mat-list>
      </mat-expansion-panel>

    </ng-container>

    <div *ngIf="!filteredIndex || !filteredIndex.length" class="no-data">{{'help.no_data' | translate}}</div>

  </ng-container>

  <markdown *ngIf="isMarkdown" class="markdown">{{selectedReadme}}</markdown>

  <button (click)="goBack()" *ngIf="isMarkdown" color="primary" mat-raised-button>Back</button>

</div>




